import classNames from "classnames";
import React, { useEffect } from "react";
import { Table, Form } from "react-bootstrap";
import { shortDurationString } from "../utils";

const CycleStageListView = (props) => {
  const { items = [], selectedIds = [], onToggle = () => {} } = props;

  const [viewItems, setViewItems] = React.useState([]);
  const percentages = Array.from({ length: 11 }, (_, i) => `${i * 10}%`);

  useEffect(() => {
    const vi = items.map((item) => {
      const totalCycleDuration = item.cycle_stages.reduce((acc, stage) => {
        return acc + stage.duration;
      }, 0);
      return {
        id: item.id, // keep id for selection
        name: item.name,
        cycle_stages: item.cycle_stages.map((stage) => {
          return {
            name: stage.name,
            duration: stage.duration,
            is_productive: stage.is_productive,
            proportion: stage.duration / (totalCycleDuration || 1),
          };
        }),
        total_cycle_duration: totalCycleDuration,
      };
    });
    setViewItems(vi);
  }, [items]);

  const renderTableRows = () => {
    return viewItems.map((cycle) => (
      <tr key={cycle.id}>
        {/* Checkbox + name column */}
        <td className="align-middle text-start w-25">
          <div className="d-flex align-items-center gap-2">
            <Form.Check
              type="checkbox"
              className="form-check-inline m-0 p-0"
              checked={selectedIds.includes(cycle.id)}
              onChange={(e) => onToggle(cycle.id, e.target.checked)}
            />
            <div className="d-flex flex-column">
              <div className="fw-semibold">{cycle.name}</div>
              <div className="text-muted small">
                {shortDurationString(cycle.total_cycle_duration)}
              </div>
            </div>
          </div>
        </td>

        {/* Timeline/proportions column */}
        <td className="align-middle py-4">
          <div className="d-flex align-items-center">
            {cycle?.cycle_stages?.map((stage, index) => (
              <div
                key={index}
                data-prop={Math.ceil(stage.proportion) * 10}
                className={`font-size-14px text-center w-${
                  Math.round((stage.proportion * 100) / 10) * 10
                }`}
              >
                {stage.name}, {shortDurationString(stage.duration)}
              </div>
            ))}
          </div>
          <div className="d-flex align-items-center">
            {cycle?.cycle_stages?.map((stage, index) => {
              return (
                <div
                  key={index}
                  className={classNames(
                    {
                      "border-radius-left-4px": index === 0,
                      "border-radius-right-4px":
                        index === cycle.cycle_stages.length - 1,
                      "bg-success": stage.is_productive,
                      "bg-danger": !stage.is_productive,
                    },
                    `border w-${
                      Math.round((stage.proportion * 100) / 10) * 10
                    } py-1`
                  )}
                ></div>
              );
            })}
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <Table bordered>
      <thead>
        <tr>
          <th className="w-25">Cycle</th>
          <th className="font-size-14px d-flex justify-content-between font-weight-normal bg-light">
            {percentages.map((percentage, index) => (
              <div key={index}>{percentage}</div>
            ))}
          </th>
        </tr>
      </thead>
      <tbody>{renderTableRows()}</tbody>
    </Table>
  );
};

export default CycleStageListView;
